<template>
    <div :id="id" class="menu" :class="{ 'show': show }">
        <slot />
    </div>
</template>

<script>
import UUID from "src/modules/uuid"

export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: 'fit-content',
        }
    },
    mounted() {
        this.menu = document.getElementById(this.id)
        this.menu.style.width = this.width
    },
    data() {
        return {
            id: new UUID().ID(),
            menu: null,
        }
    },
    watch: {
        width(newWidth) {
            this.menu.style.width = newWidth
        }
    }
}
</script>

<style lang="scss" scoped>
@import "src/../node_modules/bootstrap/scss/bootstrap.scss";
.menu {
    position: fixed;
    top: 0;
    right: 0;
    left: auto;
    z-index: 1000;
    
    max-width: 100%;
    height: 100vh;
    background-color: white;

    display: flex;
    flex-direction: column;

    transition: transform 200ms ease;
    transform: translateX(100%);

    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    @include media-breakpoint-up(md) {
   		max-width: calc(100% - 3rem);
    }
}
.menu.show {
    transform: translateX(0);
    box-shadow: 0 0 1rem 0 rgba(0,0,0,0.2);
}
</style>